import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSend = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.128 5.766 3.712 6.777c-.65.043-1.21.442-1.462 1.042a1.7 1.7 0 0 0 .277 1.774l3.345 3.903 5.575-2.755a.518.518 0 0 1 .46.93L6.33 14.425l1.067 5.028c.135.637.61 1.134 1.24 1.298a1.699 1.699 0 0 0 1.716-.529L20.525 8.595c.463-.53.557-1.25.246-1.88a1.681 1.681 0 0 0-1.643-.948Z"
    />
  </svg>
);
export default SvgSend;
